import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableCustom, SearchBarBox, HeadlinePage } from 'components/common';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Paper } from '@mui/material';
import { useForm } from 'react-hook-form';
import { withPermission } from 'hoc';


const CredentialOldListDumb = ({
  handleSearch,
  handleCreate,
  handleEdit,
  handleDelete,
  defaultValues,
  content,
  options,
  isLoaded,
  validPermission
}) => {
  const methods = useForm({ defaultValues });
  const projectId = methods.getValues('project');
  const [t] = useTranslation();

  const onSubmit = (data) => {
    handleSearch(data);
  };

  const onDelete = (credential) => {
    handleDelete(credential);
  };

  const onEdit = (credential) => {
    handleEdit(credential);
  };

  const createActions = () => {
    const actions = [];

    if (validPermission(projectId, 'isEdit')) actions.push({
      label: t('credentialList.components.table.edit'),
      icon: <EditOutlinedIcon color="primary" />,
      handle: onEdit,
    });
    if (validPermission(projectId, 'isDelete')) actions.push({
      label: t('credentialList.components.table.delete'),
      icon: <HighlightOffIcon color="primary" />,
      handle: onDelete,
    });

    return actions;
  }

  const columns = [
    { label: '#', key: 'credentials_id' },
    { label: t('common.components.table.col.name'), key: 'name' },
  ];

  const actions = createActions();

  return (
    <>
      <HeadlinePage
        title="credentialList.headline"
        buttonLabel={validPermission(projectId, 'isCreate') ? "credentialList.components.add" : ""}
        handleOnClick={handleCreate}
      />

      <SearchBarBox
        onSubmit={onSubmit}
        methods={methods}
        options={options}
        hideSearch={true}
      />

      <Paper sx={{ p: 2 }}>
        <TableCustom
          title="credentialList.components.titleList"
          columns={columns}
          content={content}
          actions={actions}
          loading={isLoaded}
          handleNotResults={handleCreate}
        />
      </Paper>
    </>
  )
}

export default withPermission(CredentialOldListDumb, "credentials");
